import api from '@/services/api/api'

class CurrenciesService {
  getAllCurrencies () {
    return api.get('currency').then(result => {
      return result.data
    })
  }
}

export default new CurrenciesService()



// WEBPACK FOOTER //
// ./src/services/codebooks/CurrenciesService.js